import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { ThemeProvider } from './context/ThemeContext'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Tenders from './pages/Tenders'
import TenderDetails from './pages/TenderDetails'
import Proposals from './pages/Proposals'
import ProposalGenerator from './pages/ProposalGenerator'
import ProposalEditor from './pages/ProposalEditor'
import TemplateManager from './pages/TemplateManager'
import Leads from './pages/Leads'
import LeadDetails from './pages/LeadDetails'
import Events from './pages/Events'
import EventDetails from './pages/EventDetails'
import Alerts from './pages/Alerts'
import GTMResearch from './pages/GTMResearch'
import TeamManagement from './pages/TeamManagement'
import Settings from './pages/Settings'
import Profile from './pages/Profile'
import Assets from './pages/Assets'
import Login from './pages/Login'
import ChangePassword from './pages/ChangePassword'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import SharedProposal from './pages/SharedProposal'
import SharedDocuments from './pages/SharedDocuments'
import SharedDocumentViewer from './pages/SharedDocumentViewer'
import { useAuthStore } from './store/authStore'

const queryClient = new QueryClient()

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
        <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/shared/proposal/:token" element={<SharedProposal />} />
          <Route path="/shared/:slug" element={<SharedDocumentViewer />} />
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/tenders" element={<Tenders />} />
                    <Route path="/tenders/:id" element={<TenderDetails />} />
                    <Route path="/proposals" element={<Proposals />} />
                    <Route path="/proposals/generate" element={<ProposalGenerator />} />
                    <Route path="/proposals/edit/:id" element={<ProposalEditor />} />
                    <Route path="/proposals/templates" element={<TemplateManager />} />
                    <Route path="/leads" element={<Leads />} />
                    <Route path="/leads/:id" element={<LeadDetails />} />
                    <Route path="/events" element={<Events />} />
                    <Route path="/events/:id" element={<EventDetails />} />
                    <Route path="/alerts" element={<Alerts />} />
                    <Route path="/gtm-research" element={<GTMResearch />} />
                    <Route path="/team" element={<TeamManagement />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/assets" element={<Assets />} />
                    <Route path="/shared-documents" element={<SharedDocuments />} />
                  </Routes>
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default App
